import { useState, useEffect, useCallback, useMemo } from "react";
import { dmmSubdimensionsResults } from "../../../../services/api-services";
import { toastEmitter } from "../../../../utills/utilities";
import SubDimensionCharts from "./RadarDimenstionChartData";
import { API_RESPONSE } from "../../../../utills/app-constant";
import Remark from "../Remark";

const RadarChart = ({ selectedCompanyId, graphName, myhandleExport }) => {
  const [responseBody, setResponseBody] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState("");
  const [remarkId, setRemarkId] = useState(null);
  const [isAttempt, setIsAttempt] = useState("");

  // API call memoized with useCallback to avoid unnecessary re-creation
  const getSubdimensionData = useCallback(async () => {
    if (!selectedCompanyId) return;
    setLoading(true);
    try {
      const response = await dmmSubdimensionsResults(selectedCompanyId, graphName);
      if (response?.data?.responseCode === 200) {
        const { responseBody, remark = "", remarkId = null, isAttempt = 0 } = response?.data;
        setResponseBody(responseBody || []);
        setRemark(remark);
        setRemarkId(remarkId);
        setIsAttempt(isAttempt);
      } else if (response?.data?.responseCode === 404) {
        setResponseBody([]);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setLoading(false);
    }
  }, [selectedCompanyId, graphName]);

  useEffect(() => {
    getSubdimensionData();
  }, [getSubdimensionData]);

  // Memoizing responseBody to prevent unnecessary re-renders
  const memoizedResponseBody = useMemo(() => responseBody, [responseBody]);

  return (
    <div>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <SubDimensionCharts
          responseBody={memoizedResponseBody}
          myhandleExport={myhandleExport}
          remark={remark}
        />
      )}
      <Remark
        selectedCompanyId={selectedCompanyId}
        graphName="DimensionsRadar"
        initialRemark={remark}
        remarkId={remarkId}
        isAttempt={isAttempt}
        setRemarkprops={setRemark}
      />
    </div>
  );
};

export default RadarChart;

